import { Link } from "react-router-dom";
import { useShop } from "@/context/ShopContext";
import { img } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import useSeo from "@/lib/useSeo";

const Block = ({ n, title, text, testId }) => (
  <div data-testid={testId} className="grid lg:grid-cols-12 gap-6 py-14 border-t border-[var(--mm-line)]">
    <span className="lg:col-span-2 font-serif-mm italic text-3xl text-[var(--mm-red)]">{n}</span>
    <h2 className="lg:col-span-3 eyebrow pt-3">{title}</h2>
    <p className="lg:col-span-6 text-base sm:text-lg leading-relaxed whitespace-pre-line">{text}</p>
  </div>
);

export default function About() {
  useSeo("About Us", "The story, inspiration and vision behind Maison Madison.");
  const s = useShop().settings || {};
  return (
    <div data-testid="about-page">
      <section className="px-5 sm:px-10 lg:px-16 pt-16 sm:pt-24 pb-16 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <p className="eyebrow text-[var(--mm-red)] mb-6 rise">About Maison Madison</p>
          <h1 className="font-serif-mm text-5xl sm:text-6xl lg:text-7xl leading-[0.98] rise d1">{s.about_title}</h1>
        </div>
        <div className="lg:col-span-4 lg:col-start-9 rise d2"><Logo className="w-full max-w-xs h-auto" testId="about-logo-img" /></div>
      </section>
      <section className="grid lg:grid-cols-12 gap-1 px-5 sm:px-10 lg:px-16">
        <div className="lg:col-span-8 aspect-[4/3] bg-[var(--mm-sand)] overflow-hidden img-zoom">{s.about_image_1 && <img data-testid="about-image-1" src={img(s.about_image_1)} alt="Maison Madison atelier" className="w-full h-full object-cover" />}</div>
        <div className="lg:col-span-4 aspect-[3/4] lg:aspect-auto bg-[var(--mm-sand)] overflow-hidden img-zoom">{s.about_image_2 && <img data-testid="about-image-2" src={img(s.about_image_2)} alt="Maison Madison detail" className="w-full h-full object-cover" />}</div>
      </section>
      <section className="px-5 sm:px-10 lg:px-16 py-20">
        <Block n="i." title="Our story" text={s.about_story} testId="about-story" />
        <Block n="ii." title="Inspiration" text={s.about_inspiration} testId="about-inspiration" />
        <Block n="iii." title="Vision" text={s.about_vision} testId="about-vision" />
      </section>
      <section className="bg-[var(--mm-red)] text-[var(--mm-cream)] px-5 sm:px-10 lg:px-16 py-20 flex flex-col sm:flex-row sm:items-end justify-between gap-8 relative grain">
        <p className="font-serif-mm text-4xl sm:text-6xl leading-none relative">Made slowly.<br /><em>Worn forever.</em></p>
        <Link to="/shop" data-testid="about-shop-button" className="relative inline-flex items-center justify-center px-9 py-4 bg-[var(--mm-cream)] text-[var(--mm-red)] eyebrow hover:bg-[var(--mm-ink)] hover:text-[var(--mm-cream)] transition-colors">Shop the collection</Link>
      </section>
    </div>
  );
}
